import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const BidderSourcesTable = ({ sources, onRemove, onUpdate, onSort }) => {
    const rows = sources.map((source, index) => <Row key={index} source={source} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('name')}>Name</th>
                    <th onClick={() => onSort('percent')} >Percent</th>
                    <th>Types</th>
                    <th onClick={() => onSort('adult')} >Adult</th>
                    <th onClick={() => onSort('factor')}>Factor</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderSourcesTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderSources/components/Table/index.js